import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import DropDown from '../common/dropDownOne';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';


module.exports = class TrearmentBoxOption extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: this.props.selected,
            firstVal: ''
        };
    }

    getValue() {
        return this.state.selected;
    }

    checkInput(evt) {
        this.setState({ selected: evt.target.value });
        if (this.props.onChange)
        {
            this.props.onChange(evt.target.value);
        }
    }

    changeValue(selected) {
        if (this.state.firstVal == '') {
            this.setState({ firstVal: selected })
        }
        this.setState({
            selected: selected
        });
    }

    render() {
        var _this = this;
        var viewName = this.props.view;
        var selected = this.state.selected;
        var firstVal = this.state.firstVal;
        var inputData = this
            .props
            .options
            .map(function (item, i) {
                var itemID = viewName + '_' + item.key;
                var className = "toggleSet " + (firstVal == item.key ? 'firstChecked' : '')
                return (
                    <span key={item.key} className={className} >
                        <input id={itemID} name={viewName} value={item.key} type="radio" checked={selected == item.key ? true : false} onChange={_this.checkInput.bind(_this)} />
                        <label htmlFor={itemID} onClick="">
                            <div>{item.name}</div></label>
                    </span>
                );
            });

        var className = 'treatmentBoxOption ' + this.props.className;

        return (
            <div className={className}>
                <div className='treatmentBoxOptionTitle'>
                    <img src={this.props.imgUrl} />
                    {this.props.Title}
                    <span className='bracket'>{this.props.BracketTitle}</span>
                </div>

                <fieldset>
                    <div className="switch-toggle well">
                        {inputData}
                    </div>
                </fieldset>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./modules/doctorAdvice/TrearmentBoxOption.jsx